// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3L6yX","col":"styles_col__2rq8Q"};